export default __webpack_public_path__ + "static/media/CIA.af2fe49d.png";